const state = () => ({
  routerPath: window.location.pathname,
})

const actions = {
  changRouterPath({ commit }, path) {
    commit('changRouterPath', path)
  },
}

const mutations = {
  changRouterPath(state, path) {
    // 路由状态切换
    state.routerPath = path;
  },
}

export default{
  namespace: true,
  actions: actions,
  mutations: mutations,
  state: state
}
// todo: 全局路由状态监听